@if (inputData.propertyConfig.name === 'vehicleRust' && value === 'NO') {
  <div
    class="d-flex align-items-center notification-message mb-2 ml-1">
    <nb-icon icon="alert-circle" size="small" class="offer-warning-icon mr-1 custom-icon-notification"></nb-icon>
    {{ 'FORM_VALIDATION.VEHICLE_RUST_NOTIFICATION_MSG' | translate }}
  </div>
}

@if (
  inputData.propertyConfig.name === 'houseSquareMeters' &&
  inputData.propertyConfig.settings?.maxSquareMeters &&
  inputData.propertyConfig.settings?.maxSquareMeters(value)) {
  <div
    class="d-flex align-items-center notification-message mb-2 ml-1">
    <nb-icon icon="alert-circle" size="small" class="offer-warning-icon mr-1 custom-icon-notification"></nb-icon>
    {{ 'FORM_VALIDATION.HOUSE_SQUARE_METERS_MAX_LENGTH' | translate }}
  </div>
}